var exports = {
  "p": "x1cb7f6e3--1b33ad--list",
};

module.exports = exports;
